import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import SendIcon from "assets/icons/send_purple.svg?react";
import moment from "moment";
import { ItemKind } from "dto/IKindItems";
import { useTranslation } from "react-i18next";

const ExpiredModal: FC<Props> = ({ pack }) => {
  const { t } = useTranslation();
  const signature = pack.Case?.Signature ?? t("common.noSignature");
  const entity = pack.Sender;
  const c = pack.Case?.Title ?? t("cases.noCaseSubject");
  const client = pack.Case?.Client ?? t("cases.noClientSpecified");

  return (
    <div className={styles.wrapper}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <div className={styles.title}>{t("packages.parcelData")}</div>
          <div className={styles.date}>
            <SendIcon className={styles.icon} />{" "}
            {moment(pack.SendDate).format("DD.MM.YYYY HH:mm").toString()}
          </div>
          <div className={styles.form}>
            {pack?.Kind === ItemKind.EDeliveryMessage && (
              <Input
                disabled
                value={t("packages.eDelivery")}
                label={t("forms.packageType")}
                onChange={() => {}}
              />
            )}
            {pack?.Kind === ItemKind.EDeliveryMessage && (
              <Input
                disabled
                value={pack?.Id}
                label={t("packages.packageId")}
                onChange={() => {}}
              />
            )}
            <Input
              disabled
              value={entity}
              label={
                pack?.Kind === ItemKind.CourtPortalDeliverance
                  ? t("packages.leadingAuthority")
                  : t("forms.sender")
              }
              onChange={() => {}}
            />
            {pack?.Kind === ItemKind.EDeliveryMessage && (
              <Input
                disabled
                value={pack?.S1}
                label={t("forms.title")}
                onChange={() => {}}
              />
            )}

            {pack?.Kind === ItemKind.CourtPortalDeliverance && (
              <Input
                disabled
                value={signature}
                label={t("packages.caseSignature")}
                onChange={() => {}}
              />
            )}

            {pack?.Kind === ItemKind.CourtPortalDeliverance && (
              <Input
                disabled
                value={c}
                label={t("cases.caseSubject")}
                onChange={() => {}}
              />
            )}
            {pack?.Kind === ItemKind.CourtPortalDeliverance && (
              <Input
                disabled
                value={client}
                label={t("cases.client")}
                onChange={() => {}}
              />
            )}

            {pack?.Kind === ItemKind.EDeliveryMessage &&
              pack.ExpirationTime && (
                <Input
                  disabled
                  value={moment(pack.ExpirationTime).format(
                    "DD.MM.yyyy HH:mm:ss"
                  )}
                  label={t("packages.receiveBy")}
                  onChange={() => {}}
                />
              )}
          </div>
          <div className={styles.error}>{t("packages.receiptExpired")}</div>
        </div>
      </div>
    </div>
  );
};

export default ExpiredModal;
